import { render } from "./ConfirmDelete.vue?vue&type=template&id=2b644eab&scoped=true"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"

import "./ConfirmDelete.vue?vue&type=style&index=0&id=2b644eab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b644eab"]])

export default __exports__